export const MAX_SEARCH_LENGTH = 200

export interface SearchItem {
  id: number
  name: string
  additional_info?: string | null
  tag: number
  tag_name: string
  obj_url: string
}

export interface SearchResponse {
  success: boolean
  data: SearchItem[]
  paginator: { page: number; count: number; objects_count: number }
}

export const normalizeSearchQuery = (value: string) =>
  value.trim().replace(/\s+/g, ' ')

// Подсказки содержат только внутренние карточки. У новостей в Next.js другой URL.
export const searchObjectPath = (url: string): string | null => {
  const match = /^\/(programs|events|units|posts|news)\/(\d+)\/?$/.exec(url)
  if (!match) return null
  return `/${match[1] === 'posts' ? 'news' : match[1]}/${match[2]}`
}
